import { Component, OnInit,Input,EventEmitter,Output} from '@angular/core';
import{ContentManagementService} from '../../../Services/content-management/content-management.service';
import { StudyUnitTopic } from 'src/app/Models/StudyUnitTopic';
import { QuestionStatusModel } from 'src/app/Models/QuestionStatusById';
import { FormBuilder, FormGroup } from '@angular/forms';
import { VStudyUnit } from 'src/app/Validators/Validators';
import { ToastrService } from "ngx-toastr";
import { ChangeDetectorRef } from '@angular/core';
import { Pipe, PipeTransform } from '@angular/core';

@Component({
  selector: 'app-content-studymaterial-statuslist',
  templateUrl: './content-studymaterial-statuslist.component.html',
  styleUrls: ['./content-studymaterial-statuslist.component.css']
})
export class ContentStudymaterialStatuslistComponent implements OnInit {
  @Input() Selectedstudymaterial:any;
  @Output() returnstatusclose : EventEmitter<any> = new EventEmitter<any>();

  constructor(private cdr: ChangeDetectorRef,public service:ContentManagementService,private fb: FormBuilder,private toastr: ToastrService) {

    
   }

  ngOnInit(): void {
    this.getStudymaterialstatuslist(this.Selectedstudymaterial);
  }

  getStatus:any;
  response:any;
  getStudymaterialstatuslist(data:any) {
    this.service.GetStatusList({ 'Study_Material_Id': data }).subscribe((i: any) => {
      this.response=i;
     
      if(this.response.data!=null){
        this.getStatus=this.response.data;

        console.log(this.getStatus,'this.getStatus');
        }
        else{
          this.toastr.error(this.getStatus.Message);
        }
      }, error => { 
         console.log(error);
         this.toastr.error(this.getStatus.Message);
         }
      );
      }


      closepopup(){
        this.returnstatusclose.emit(1)
      }
    }
 


    


